import { render, staticRenderFns } from "./BonusQuickstartRewardsItem.vue?vue&type=template&id=10a82813&scoped=true"
import script from "./BonusQuickstartRewardsItem.vue?vue&type=script&lang=js"
export * from "./BonusQuickstartRewardsItem.vue?vue&type=script&lang=js"
import style0 from "./BonusQuickstartRewardsItem.vue?vue&type=style&index=0&id=10a82813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a82813",
  null
  
)

export default component.exports